import { CardStyleInterpolators } from '@react-navigation/stack';
import React, { useEffect, useRef } from 'react';
import { GestureConflictHandleView } from '../GestureConflictHandleView';
import { PanGestureHandler, ScrollView, State } from '../GestureHandler';
import { useNavigation } from '@/hooks/useNavigation';

export function HorizontalGestureConflictView(props: { children: any }) {
    return (
        <GestureConflictHandleView canScrollLeft canScrollRight>
            {props.children}
        </GestureConflictHandleView>
    );
}
